export default "__VITE_ASSET__bea68c9a__"